import { DocumentFragment } from "@/__generated__/graphql";
import { DataViewThreadActions } from "@/components/organisms/DataView/DataViewThreadActions";
import { type TableDialogSelectionActionsProps } from "@/components/organisms/Table/TableDialog";
import { ThreadMessageContextItemType } from "@/state/@types";

export function documentToThreadContext(
  document: DocumentFragment,
): ThreadMessageContextItemType {
  return {
    id: document.id,
    identifier: document.identifier,
    name: document.name || document.description || "Untitled",
    typename: "DocumentObject",
  };
}

export const DOCUMENT_THREAD_MENU_OPTIONS = [
  { id: "reconcile", message: "Reconcile" },
  { id: "matching-transactions", message: "Find matching transactions" },
] as const;

type DocumentsViewThreadActionsProps = TableDialogSelectionActionsProps & {
  onPrepareThread: (checkedRowIds: string[], draft?: string) => void;
};

export function DocumentsViewThreadActions({
  menuOptions = DOCUMENT_THREAD_MENU_OPTIONS,
  ...props
}: DocumentsViewThreadActionsProps & {
  menuOptions?: typeof DOCUMENT_THREAD_MENU_OPTIONS;
}) {
  return <DataViewThreadActions {...props} menuOptions={[...menuOptions]} />;
}
